import { Box, FormControl, FormControlLabel, Grid2 as Grid, Icon, Radio, Typography } from "@mui/material";

type RadioProps = {
    selected: number,
    setSelected: (v: any) => void,
    value: number,
    title: string,
    caption: string,
    img?: React.ComponentType<{}>,
    isRow?: boolean,
    size?: number
}

const FormRadio = ({ selected, setSelected, value, title, caption, img = undefined, isRow = true, size = 4}: RadioProps) => {
    return (
        <Grid size={size}>
            <FormControl fullWidth>
                <FormControlLabel
                    value={value}
                    checked={selected === value}
                    onChange={(_e) => { 
                        setSelected(value)
                    }}
                    control={<Radio />}
                    sx={ { p: 1, justifyContent: isRow ? "center" : null }}
                    label={
                        <Box display="flex" alignItems="center" gap={2}>
                            {img !== undefined && <Icon fontSize="large" component={img} />}
                            <Box display="flex" flexDirection="column">
                                <Typography variant="h6">{title}</Typography>
                                <Typography variant="body2" component="pre">{caption}</Typography>
                            </Box>
                        </Box>
                    }
                />
            </FormControl>
        </Grid>
    )
}

export default FormRadio;
